import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import FlatFee from '../../entities/flatFee';
import Invoice from '../../entities/invoice';
import Task from '../../entities/task';

/*
 * Delete/nullify anywhere this flatFee is used in other entities
 *
 * @param {FlatFee} flatFee
 */
export function deleteFlatFee(flatFee: FlatFee, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = flatFee.id;
    }
    /* Simple delete usages */
        
    store.getState().invoices
        .getMappingFor('flatFeeId', flatFee.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.flatFeeIds = _invoice.flatFeeIds?.filter(id => id !== flatFee.id) || [];
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    store.getState().tasks
        .getMappingFor('flatFeeId', flatFee.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.flatFeeBucket = null;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    /* Remove the actual flatFee */
    flatFee.status = 'D';
    flatFee.addedOn = newHRTimestamp();
    flatFee.addedBy = getCurrentUserId();
    flatFee.importSource = targetImportSource;
    flatFee.importId = mergeId;
    store.dispatch(Actions.FlatFeeActions.removeFlatFeeQueue(flatFee));
    
}

/*
 * Replace anywhere this flatFee is used in other entities.
 *
 * @param {FlatFee} flatFee
 * @param {FlatFee} replaceWith
 * @return {FlatFee} - FlatFee will have refs stripped away
 */
export function replaceFlatFee(flatFee: FlatFee, replaceWith: FlatFee, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = flatFee.id;
    }
    /* Simple replace usages */
        
    store.getState().invoices
        .getMappingFor('flatFeeId', flatFee.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.flatFeeIds = _invoice.flatFeeIds?.map(id => (id === flatFee.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    store.getState().tasks
        .getMappingFor('flatFeeId', flatFee.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.flatFeeBucket = replaceWith.id;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    return flatFee;
}

/*
 * Determine the impact of deleting this flatFee from other entities
 *
 * @param {FlatFee} flatFee
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactFlatFee(flatFee: FlatFee) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const invoiceFlatFeeIdsImpact = state.invoices
          .getMappingFor('flatFeeId', flatFee.id)
          .filter(invoice => invoice.status !== 'D');

    invoiceFlatFeeIdsImpact.forEach(() => impacts.push('invoices'));

    const taskFlatFeeBucketImpact = state.tasks
          .getMappingFor('flatFeeId', flatFee.id)
          .filter(task => task.status !== 'D');

    taskFlatFeeBucketImpact.forEach(() => impacts.push('tasks'));

    return util.countDistinct(impacts);
}